import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";

import "../assets/fonts/Inter.ttf";

export default createGlobalStyle`
  
@font-face {
    font-family: "Inter";
    src: local("Inter"),
    url("../assets/fonts/Inter.ttf") format("truetype");
}

* {
    font-family: "Inter", sans-serif;
}

*{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
}

#root {
    margin: 0 auto;
    background-color: ${theme.colors.bgBody};

  // For rem units.
    font-size: 16px;

}
body {
    overflow: hidden;
}

html {
    scroll-padding-top: 64px;
}
`;
